export const projects = [
  {
    title: "DanFlix",
    description:
      "Using themoviedb api, I designed a small movie list web app for movie enthusiast.",
    image: "/images/danflix.png",
    image2: "/images/danflix2.png",
    tags: ["React"],
    source: "https://daflix.netlify.com",
    visit: "https://daflix.netlify.com",
    id: 0,
  },
  {
    title: "Anna Digital Health Solutions",
    description:
      "It plans to connect hospitals for easier referral of patients.",
    image: "/images/anna.png",
    image2: "/images/anna2.png",
    tags: ["React", "Redux", "Express", "MongoDB"],
    source: "https://google.com",
    visit: "https://annadigitalsolutions.com",
    id: 2,
  },
  {
    title: "Google Clone",
    description:
      "A simple google-clone web app, Using react.js and Google API.",
    image: "/images/google.png",
    image2: "/images/google2.png",
    tags: ["React", "Redux", "Google-API"],
    source: "https://google-clone2.com",
    visit: "https://google-clone2.netlify.com",
    id: 3,
  },
  {
    title: "Musika",
    description:
      "Musika is a small music streaming service. It allows you to listen to music. React & Deezer API is used to create this project.",
    image: "/images/music.png",
    image2: "/images/music2.png",
    tags: ["React", "Redux", "Deezer-API"],
    source: "https://google.com",
    visit: "https://musika2.netlify.com",
    id: 4,
  },
  {
    title: "E-Commerce",
    description: "An E-commerce web-app, Using Vue.js and Laravel",
    image: "./images/ecom.png",
    image2: "/images/ecom2.png",
    tags: ["Vue", "Vuex", "Laravel", "Mysql"],
    source: "https://google.com",
    visit: "",
    id: 1,
  },
  // {
  //   title: "Social App",
  //   description:
  //     "Using React, Node.js, Express & MongoDB you'll learn how to build a Full Stack MERN Application",
  //   image: "./images/social.png",
  //   image2: "/images/social2.png",
  //   tags: ["Vue", "Vuex", "Laravel", "Firebase"],
  //   source: "https://google.com",
  //   visit: "",
  //   id: 5,
  // },
  {
    title: "Inventory System",
    description:
      "An expenditure tracker for everyday spending, Using Express and React",
    image: "./images/expense.png",
    image2: "/images/expense2.png",
    tags: ["React", "Redux", "Express.js", "Postgresql"],
    source: "https://google.com",
    visit: "",
    id: 6,
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
